import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";

class returnDataAccess {
  returnList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "Return/getAll",
      parameters
    );
  };
  

  saveReturnsInfo = (payload: any) => {
    return commonDataAccess.postData("Return/save/", payload);
  };

  getReturnById = async (id: number) => {
    return await commonDataAccess.getData(`Return/getById/${id}`, {});
  };


  deleteReturnInfo = (ids: number | number[]) =>{
    if(Array.isArray(ids)){
      return commonDataAccess.postData("Return/deleteAll", ids);
    }else{
      return commonDataAccess.deleteData(`Return/delete/${ids}`);
    }
  }

}


export default new returnDataAccess();
